export default "__VITE_ASSET__DdH4eDkL__"